import React from 'react'

function AvisoIntegral() {
  return (
    <embed src="https://firebasestorage.googleapis.com/v0/b/rhesident-page-dev.appspot.com/o/files%2Fdescargas%2FAviso%20Integral?alt=media&token=d2558d80-8d9c-4d28-9b27-fa745a7933af" width="100%" height="1200px" />
     
  );
}

export default AvisoIntegral